import React from "react";

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer-container">
                    <div className="footer-logo">
                        <h2>SOFTGRAY</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        {/* <a href="#" className="fa fa-facebook"></a>
                        <a href="#" className="fa icons fa-twitter"></a>
                        <a href="#" className="fa fa-instagram"></a> */}
                    </div>
                    <div className="footer-links">
                        <div className="platform">
                            <h3>Platform</h3>
                            <ul>
                                <a href="#"><li>How it Works</li></a>
                                <a href="#"><li>Checkout</li></a>
                                <a href="#"><li>Fraud</li></a>
                                <a href="#"><li>Protection</li></a>
                                {/* <a href="#"><li>Payments</li></a>
                                <a href="#"><li>Accounts</li></a> */}
                            </ul>
                        </div>
                        <div className="learning">
                            <h3>Learn</h3>
                            <ul>
                                <a href="#"><li>Resources</li></a>
                                <a href="#"><li>Blog</li></a>
                                <a href="#"><li>FAQs</li></a>
                                <a href="#"><li>ThinkShop</li></a>
                            </ul>
                        </div>
                        <div className="About">
                            <h3>About</h3>
                            <ul>
                                <a href="#"><li>Careers</li></a>
                                <a href="#"><li>Team</li></a>
                                <a href="#"><li>Partners</li></a>
                                <a href="#"><li>Contact Us</li></a>
                                {/* <a href="#"><li>News & Press</li></a> */}
                            </ul>
                        </div>
                    </div>
                    <div className="footer-contactus">
                        <h2>Contact US</h2>
                        <button>Get in touch</button>
                    </div>
                </div>
                <div className="copywright-tag">&#169; Copyright SOFTGRAY. All rights reserved</div>
            </footer>
        </>
    )
}
export default Footer;